module.exports = __webpack_public_path__ + "img/immersivesphere.42b2cd49.jpg";